var map = {
	"./frontend/AndroidGuide.vue": 7881,
	"./frontend/BetslipHistory.vue": 2398,
	"./frontend/BodyFB.vue": 9185,
	"./frontend/ContactUs.vue": 5571,
	"./frontend/DataTable.vue": 6107,
	"./frontend/Deposit.vue": 8174,
	"./frontend/History.vue": 2533,
	"./frontend/Home.vue": 6285,
	"./frontend/IOSGuide.vue": 7508,
	"./frontend/Iframe.vue": 9958,
	"./frontend/Index.vue": 266,
	"./frontend/Live.vue": 6130,
	"./frontend/MainMenu.vue": 7294,
	"./frontend/MaungFB.vue": 5982,
	"./frontend/Promotion.vue": 7512,
	"./frontend/Setting.vue": 3959,
	"./frontend/VideoLink.vue": 981,
	"./frontend/Withdraw.vue": 6532,
	"./frontend/auth/Login.vue": 7868,
	"./frontend/auth/Register.vue": 5218,
	"./frontend/auth/Rule.vue": 4557,
	"./frontend/components/AccountSelect.vue": 3678,
	"./frontend/components/DataTable.vue": 3713,
	"./frontend/components/FBPreviewVoucher.vue": 630,
	"./frontend/components/FBVoucher.vue": 6329,
	"./frontend/components/FootballTeamCard.vue": 6924,
	"./frontend/components/GroupBox.vue": 9111,
	"./frontend/components/InputSelectDrawModal.vue": 7296,
	"./frontend/components/LuckyWheel.vue": 187,
	"./frontend/components/NormalBox.vue": 3540,
	"./frontend/components/PreviewVoucher.vue": 7513,
	"./frontend/components/SideNav.vue": 850,
	"./frontend/components/Table.vue": 1210,
	"./frontend/components/ThreedGroupBox.vue": 5959,
	"./frontend/components/ThreedQuickGroupBox.vue": 8508,
	"./frontend/components/TwoDSelect.vue": 8815,
	"./frontend/components/Voucher.vue": 1739,
	"./frontend/normal-user/2d/2d.vue": 9282,
	"./frontend/normal-user/2d/ClosedDays.vue": 2994,
	"./frontend/normal-user/2d/Home.vue": 4586,
	"./frontend/normal-user/2d/Winner.vue": 1532,
	"./frontend/normal-user/3d/3d.vue": 6827,
	"./frontend/normal-user/3d/Home.vue": 6470,
	"./frontend/normal-user/DreamBooks.vue": 7661,
	"./frontend/normal-user/Index.vue": 6012,
	"./frontend/normal-user/bugyee/Room.vue": 7576,
	"./frontend/normal-user/game/Fishing.vue": 9659,
	"./frontend/normal-user/game/Game.vue": 1217,
	"./frontend/normal-user/game/Slot.vue": 6175,
	"./frontend/normal-user/shankomee/Room.vue": 703
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5477;